import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import style from './style.module.css'

export const MainContent = () => {
  const { t } = useTranslation()

  return (
    <div className={clsx(style.wrapper)}>
      {/* ヘッダー: ログインユーザーの取得を実行しないようにしたいので共通ヘッダーは使っていない */}
      <div className={clsx(style.header)}>
        <img
          className={clsx(style.logoImage)}
          alt={t('maintenance.altairLogo')}
          src="/logo.svg"
        />
      </div>

      <div className={clsx(style.main)}>
        <div className={clsx(style.contents)}>
          <p>ただいまメンテナンスのため、一時サービスを停止しております。</p>
          <p>ご迷惑をおかけして申し訳ございません。</p>
          <p className={clsx(style.schedule)}>
            <strong>【サービス停止日時】</strong>
            <br />
            2026年2月18日（水）22:00 ～ 2月19日（木）6:00頃
            <br />
            <span className={clsx(style.note)}>
              ※メンテナンス時間は、延長される可能性がございます
            </span>
          </p>
        </div>
        <div className={clsx(style.illust)}></div>
      </div>
    </div>
  )
}
